// src/pages/document/DocumentEditPage.tsx
// Redirects to the detail page where inline editing happens.
// Kept for backwards compatibility with existing links.

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export const DocumentEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/documents/${id}`, { replace: true });
  }, [id, navigate]);

  return null;
};

export default DocumentEditPage;
